// API клиент для ref_base_tariffs (ClickHouse)
import { apiClient } from './client'

export interface BaseTariff {
  year: number
  care_type: string
  base_tariff: number
  region_code: string
  source: string | null
}

export interface BaseTariffCreate {
  year: number
  care_type: string
  base_tariff: number
  region_code?: string
  source?: string | null
}

export interface BaseTariffUpdate {
  base_tariff?: number
  source?: string | null
}

export interface BaseTariffListResponse {
  items: BaseTariff[]
  total: number
}

export const fetchBaseTariffs = async (): Promise<BaseTariffListResponse> => {
  const response = await apiClient.get<BaseTariffListResponse>('/refs/base-tariffs')
  return response.data
}

export const createBaseTariff = async (data: BaseTariffCreate): Promise<BaseTariff> => {
  const response = await apiClient.post<BaseTariff>('/refs/base-tariffs', data)
  return response.data
}

export const updateBaseTariff = async (
  year: number, careType: string, data: BaseTariffUpdate
): Promise<BaseTariff> => {
  const response = await apiClient.put<BaseTariff>(
    `/refs/base-tariffs/${year}/${encodeURIComponent(careType)}`, data
  )
  return response.data
}

export const deleteBaseTariff = async (year: number, careType: string): Promise<void> => {
  await apiClient.delete(`/refs/base-tariffs/${year}/${encodeURIComponent(careType)}`)
}

export const seedBaseTariffs = async (): Promise<BaseTariffListResponse> => {
  const response = await apiClient.post<BaseTariffListResponse>('/refs/base-tariffs/seed')
  return response.data
}
